/* eslint-disable no-unused-vars */
import { AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import { AccordionHeader, SocAccordion } from "./SOC.style";
import { IPetItemResponse, ISOCItemResponse }
  from "../../../services/Standard-of-care/standard-of-care.interface";
import React, { useEffect, useState } from "react";

import { ChipCustom } from "../../../styles/styledComponents";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ISpecificOverdueItem } from "./StandardOfCareContainer";
import SOCChildAccordion from "./SOCChildAccordion";
import { SocStatusCustomIcon } from "../../../components/Icons";
import { getSOCStatusDataMap } from "../../../utils/SOCUtils";

type Props = {
    socData: [string, ISOCItemResponse[]];
    expanded: boolean | string;
    socIcons: { [key:string]: JSX.Element };
    handleChange: (panel: string) =>
     (event: React.SyntheticEvent, isExpanded: boolean) => void;
  petData: IPetItemResponse;
  handleAccordianHeaderClick: (data: [string, ISOCItemResponse[]]) => void;
  handleAccordianSummaryClick: (data: ISOCItemResponse) => void;
  isWellnessPlan:boolean
  specificOverdueItem?: ISpecificOverdueItem | null;
  setSpecificOverdueItem?: (value: ISpecificOverdueItem | null) => void
}

const SOCAccordionCard = (props: Props) => {
  const { socData, isWellnessPlan, expanded, handleChange, handleAccordianHeaderClick,
    handleAccordianSummaryClick, socIcons, petData, specificOverdueItem, setSpecificOverdueItem } = props;
  const [expandedChild, setExpandedChild] = useState<string | false>(false);

  const handleChangeChild = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpandedChild(isExpanded ? panel : false);
    setSpecificOverdueItem && setSpecificOverdueItem({ ...specificOverdueItem, overdueItem: null });
  };

  const SOC_STATUS: any = {
    "Overdue": 0,
    "Incomplete": 0,
    "Current": 0,
    "Almost Due": 0,
  };

  socData[1].forEach((item: any) => {
    SOC_STATUS[item.status] += 1;
  });

  const getSocStatus = () => {
    if (SOC_STATUS["Overdue"] > 0) {
      return { type: "Overdue" };
    } else if (SOC_STATUS["Almost Due"] > 0) {
      return { type: "Almost Due" };
    } else if (SOC_STATUS["Incomplete"] > 0) {
      return { type: "Incomplete" };
    } else if (SOC_STATUS["Current"] > 0) {
      return { type: "Current" };
    } else {
      return { type: "" };
    }
  };

  const socStatus: { type: string } = getSocStatus();

  useEffect(() => {
    setExpandedChild(false);
  }, [petData]);

  return (
    <>
      <SocAccordion expanded={expanded === socData[0] || specificOverdueItem?.parentValue === socData[0]}
        onChange={handleChange(socData[0])}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`${socData[0]}d-content`}
          id={`${socData[0]}d-header`}
          className="!pr-4"
          onClick={() => {
            expanded !== socData[0]&& handleAccordianHeaderClick(socData);
          }}
        >
          <AccordionHeader>
            <Box className="title_icon">
              {socIcons[socData[0].toLowerCase()]}
              <Typography variant="body1" fontWeight={600}>
                {socData[0]}
              </Typography>
            </Box>
            <Box>
              <ChipCustom
                icon={<SocStatusCustomIcon type={socStatus?.type as any || "default"}/>}
                label={getSOCStatusDataMap(socStatus?.type)?.label}
                className="!font-semibold !text-xs !py-[0.375rem]
                 !px-2 "
                color={getSOCStatusDataMap(socStatus?.type)?.color}
                size="small"
              />
            </Box>
          </AccordionHeader>

        </AccordionSummary>
        <AccordionDetails>
          {socData[1].map((item: ISOCItemResponse, index: number)=>(

            <SOCChildAccordion
              key={index}
              isWellnessPlan={isWellnessPlan}
              item={item}
              expandedChild={expandedChild}
              handleChangeChild={handleChangeChild} petData={petData}
              isPreventative={socData[0] === "Preventative" ? true : false}
              onClick={handleAccordianSummaryClick}
              specificOverdueItem={specificOverdueItem && specificOverdueItem?.overdueItem?.name} />
          ))}
        </AccordionDetails>
      </SocAccordion>
    </>
  );
};

export default SOCAccordionCard;
